import { render } from "./SpecialPageDetail.vue?vue&type=template&id=6873ab38&scoped=true&ts=true"
import script from "./SpecialPageDetail.vue?vue&type=script&lang=ts"
export * from "./SpecialPageDetail.vue?vue&type=script&lang=ts"

import "./SpecialPageDetail.vue?vue&type=style&index=0&id=6873ab38&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6873ab38"]])

export default __exports__